// extracted by mini-css-extract-plugin
export default {"createdPeriod":"styles_created-period__Wta86"};